import React from 'react';
import { Pane, Text } from '@leverege/ui-elements';
import { CONSTANTS } from '../attributes/BatteryAlerts';

// TODO: stolen from recovr-server
import { jsx as _jsx } from "react/jsx-runtime";
const ALERTS = {
  [CONSTANTS.END_OF_LIFE]: 'End of Life',
  [CONSTANTS.LOW_VOLTAGE]: 'Low Voltage',
  [CONSTANTS.LOW_BATTERY]: 'Low Battery'
};
const VARIANTS = {
  [CONSTANTS.END_OF_LIFE]: 'pillError',
  [CONSTANTS.LOW_BATTERY]: 'pillWarning',
  [CONSTANTS.LOW_VOLTAGE]: 'pillWarning'
};
export default function BatteryAlerts(props) {
  const {
    value
  } = props;
  return /*#__PURE__*/_jsx(Pane, {
    variant: "tableCellContent",
    children: /*#__PURE__*/_jsx(Text, {
      variant: VARIANTS[value] || 'pillError',
      children: ALERTS[value] || value
    }, value)
  });
}